import z from "zod";

/**
 * ObraAreaEmpreendimentoChecklistSchema
 */

export const ObraAreaEmpreendimentoChecklistSchema = z.object({
  status: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).default(0),
  idIncorporacaoBloco: z.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  // Obrigatório apenas quando o bloco possui pavimentos (validado no modal).
  idIncorporacaoAndar: z.number().nullable().default(null),
  unidade: z.string({ required_error: 'Este campo deve ser preenchido!' }).trim().nonempty('Este campo deve ser preenchido!'),
  checklists: z.array(z.number()).nullable().default(null),
});

/**
 * ObraAreaEmpreendimentoChecklistForm
 */

export type ObraAreaEmpreendimentoChecklistForm = z.infer<typeof ObraAreaEmpreendimentoChecklistSchema>;

/**
 * initialObraAreaEmpreendimentoChecklist
 */

export const initialObraAreaEmpreendimentoChecklist: Partial<ObraAreaEmpreendimentoChecklistForm> = {
  status: 0,
  idIncorporacaoAndar: null,
  unidade: '',
  checklists: null,
};
